import { Button, DatePicker, Divider, Input, Select, SelectItem, Textarea } from '@heroui/react'
import React, { useEffect, useState } from 'react'
import Notiflix from "notiflix";

const AdmissionForm = () => {

    const DOMAIN = "https://oxfordcollege.lk/api/routes/"

    const [applyFor, setApplyFor] = useState([]);
    const [gender, setGender] = useState([]);
    const [relations, setRelations] = useState([]);
    const [identity, setIdentity] = useState([]);

    const initalFetch = [
        {
            name: "gender",
            setter: setGender
        },
        {
            name: "relation",
            setter: setRelations
        },
        {
            name: "identityType",
            setter: setIdentity
        },
        {
            name: "course",
            setter: setApplyFor
        }
    ]

    useEffect(() => {
        initializeData();
    }, [])

    const initializeData = async () => {
        try {
            initalFetch.forEach(async (item) => {
                const response = await fetch(DOMAIN + "other.php?route=get&data=" + item.name);
                const data = await response.json();
                item.setter(data.data);
            });
        } catch (error) {
            console.error("Error fetching data : ", error);
        }
    }

    const [formData, setFormData] = useState({
        roleId: '4',
        programId: [],
        image: '',
        admissionNumber: '',
        firstName: '',
        lastName: '',
        middleName: '',
        genderId: '',
        dob: '',
        specialNotes: '',
        address: '',
        email: '',
        mobile: '',
        identityTypeId: null, // For Admin and Teacher
        identityNumber: null, // For Admin and Teacher
        relation1: {
            relationId: '',
            firstName: '',
            lastName: '',
            email: '',
            whatsappNumber: '',
            identityTypeId: '',
            identityNumber: '',
            address: '',
        },
        relation2: {
            relationId: '',
            firstName: '',
            lastName: '',
            email: '',
            whatsappNumber: '',
            identityTypeId: '',
            identityNumber: '',
            address: '',
        }
    })

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (files) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: files[0],
            }));
        } else if (name.includes('relation1')) {
            const childName = name.split('.')[1];
            setFormData((prevFormData) => ({
                ...prevFormData,
                relation1: {
                    ...prevFormData.relation1,
                    [childName]: value,
                },
            }));
        } else if (name.includes('relation2')) {
            const childName = name.split('.')[1];
            setFormData((prevFormData) => ({
                ...prevFormData,
                relation2: {
                    ...prevFormData.relation2,
                    [childName]: value,
                },
            }));
        }else if (name === 'programId') {
            const programIds = value.split(',').map(Number);
            setFormData((prevFormData) => ({
                ...prevFormData,
                programId: programIds,
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async () => {

        Notiflix.Loading.pulse('Processing...');

        if (formData.programId === '' || formData.image === '' || formData.firstName === '' || formData.lastName === '' || formData.middleName
            === '' || formData.genderId === '' || formData.dob === '' || formData.relation1.relationId === '' || formData.relation1.firstName === ''
            || formData.relation1.lastName === '' || formData.relation1.email === '' || formData.relation1.whatsappNumber === '' || formData.relation1.identityTypeId === ''
            || formData.relation1.identityNumber === '' || formData.relation1.address === '' || formData.address === '') {

            Notiflix.Loading.remove();
            Notiflix.Notify.failure('Please fill all the required fields');

            return;
        }

        try {
            const formObject = new FormData();

            for (const key in formData) {
                if (key === "image") {
                    if (formData[key] instanceof File) {
                        formObject.append(key, formData[key]);
                    } else {
                        Notiflix.Loading.remove();
                        Notiflix.Notify.failure('Please upload a valid image file');
                    }
                } else if (key === "relation1" || key === "relation2" ||key === "programId") {
                    formObject.append(key, JSON.stringify(formData[key]));
                } else {
                    formObject.append(key, formData[key]);
                }
            }

            const response = await fetch(DOMAIN + "admission.php?route=add", {
                method: "POST",
                body: formObject,
            });

            const data = await response.json();

            if (!response.ok || data.status !== 201) {
                Notiflix.Loading.remove();
                Notiflix.Notify.failure(data.message);
            } else {
                Notiflix.Loading.remove();
                Notiflix.Notify.success(data.message);
            }
        } catch (error) {
            Notiflix.Loading.remove();
            Notiflix.Notify.failure('An error occurred');
        }
    };

    return (
        <div className='max-w-[1500px] mx-auto my-10 px-10 flex flex-col gap-y-8'>
            <div className='w-full flex flex-col gap-y-4'>
                <h3 className='uppercase text-5xl font-bebas'>Application Form For Admission</h3>
                <p className='text-neutral-400'>You agree to receive communications from the college via email, phone, or other methods regarding your application and admission process.</p>
            </div>

            <div className='bg-secondary-blue/5 rounded-xl p-6'>
                <h4 className='font-bold'>Admission At Oxford College - Gampaha</h4>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mt-4'>
                    <Select
                        isRequired
                        classNames={{ trigger: "bg-white" }}
                        label="Select Program"
                        labelPlacement='outside'
                        defaultSelectedKeys={formData.programId}
                        placeholder="Select Program"
                        name="programId"
                        onChange={handleChange}
                    >
                        {applyFor.map((item) => (
                            <SelectItem key={item.id}>{item.name}</SelectItem>
                        ))}
                    </Select>

                    <div className='flex flex-col'>
                        <span className='text-sm mb-2'>Photo of the Student <span className='text-red-500'>*</span>
                            <small className='ms-2 text-neutral-500'>(png, jpg, jpeg)</small>
                        </span>
                        <Input
                            isRequired
                            type="file"
                            classNames={{
                                inputWrapper: 'bg-white',
                            }}
                            name="image"
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>

            <div className='bg-secondary-blue/5 rounded-xl p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                <Input
                    isRequired
                    label="First Name"
                    labelPlacement='outside'
                    placeholder='John'
                    type="text"
                    classNames={{
                        inputWrapper: 'bg-white',
                    }}
                    name='firstName'
                    onChange={handleChange}
                />

                <Input
                    isRequired
                    label="Middle Name"
                    labelPlacement='outside'
                    placeholder='Alex'
                    type="text"
                    classNames={{
                        inputWrapper: 'bg-white',
                    }}
                    name='middleName'
                    onChange={handleChange}
                />

                <Input
                    isRequired
                    label="Last Name"
                    labelPlacement='outside'
                    placeholder='Criss'
                    type="text"
                    classNames={{
                        inputWrapper: 'bg-white',
                    }}
                    name='lastName'
                    onChange={handleChange}
                />

                <Select
                    isRequired
                    classNames={{ trigger: "bg-white" }}
                    label="Gender"
                    labelPlacement='outside'
                    defaultSelectedKeys={formData.genderId}
                    placeholder="Select Gender"
                    name="genderId"
                    onChange={handleChange}
                >
                    {gender.map((item) => (
                        <SelectItem key={item.id}>{item.name}</SelectItem>
                    ))}
                </Select>

                <DatePicker
                    isRequired
                    label="Date of Birth"
                    labelPlacement='outside'
                    classNames={{
                        inputWrapper: "bg-white",
                    }}
                    name="dob"
                    onChange={
                        (value) => {
                            setFormData({
                                ...formData,
                                dob: `${value.year}-${value.month}-${value.day}`
                            })
                        }
                    }
                />

                <Input
                    label="Special Note About Child"
                    labelPlacement='outside'
                    placeholder='Enter special note about child'
                    type="text"
                    classNames={{
                        inputWrapper: 'bg-white',
                    }}
                    name='specialNotes'
                    onChange={handleChange}
                />

                <Input
                    isRequired
                    label="Contact Email Address"
                    labelPlacement='outside'
                    placeholder='example@gmail'
                    type="email"
                    classNames={{
                        inputWrapper: 'bg-white',
                    }}
                    name='email'
                    onChange={handleChange}
                />

                <Input
                    isRequired
                    label="Contact Phone Number"
                    labelPlacement='outside'
                    placeholder='0771234567'
                    type="text"
                    classNames={{
                        inputWrapper: 'bg-white',
                    }}
                    name='mobile'
                    onChange={handleChange}
                />

                <Textarea
                    isRequired
                    rows={20}
                    classNames={{ inputWrapper: "bg-white" }}
                    className="col-span-full"
                    label="Address"
                    labelPlacement='outside'
                    placeholder="Please type your address here..."
                    name='address'
                    onChange={handleChange}
                />

            </div>

            <div className='bg-secondary-blue/5 rounded-xl p-6'>
                <h4 className='font-bold'>Parent/Guardian</h4>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4'>
                    <Select
                        isRequired
                        classNames={{ trigger: "bg-white" }}
                        label="Choose Relation"
                        labelPlacement='outside'
                        defaultSelectedKeys={formData.relation}
                        placeholder="Select Relation"
                        name="relation1.relationId"
                        onChange={handleChange}
                    >
                        {relations.map((item) => (
                            <SelectItem key={item.id}>{item.name}</SelectItem>
                        ))}
                    </Select>

                    <Input
                        isRequired
                        label="First Name"
                        labelPlacement='outside'
                        placeholder='James'
                        type="text"
                        classNames={{
                            inputWrapper: 'bg-white',
                        }}
                        name='relation1.firstName'
                        onChange={handleChange}
                    />

                    <Input
                        isRequired
                        label="Last Name"
                        labelPlacement='outside'
                        placeholder='Carter'
                        type="text"
                        classNames={{
                            inputWrapper: 'bg-white',
                        }}
                        name='relation1.lastName'
                        onChange={handleChange}
                    />

                    <Input
                        isRequired
                        label="Email Address"
                        labelPlacement='outside'
                        placeholder='example@gmail.com'
                        type="email"
                        classNames={{
                            inputWrapper: 'bg-white',
                        }}
                        name='relation1.email'
                        onChange={handleChange}
                    />

                    <Input
                        isRequired
                        label="WhatsApp Number"
                        labelPlacement='outside'
                        placeholder='0761234567'
                        type="text"
                        classNames={{
                            inputWrapper: 'bg-white',
                        }}
                        name='relation1.whatsappNumber'
                        onChange={handleChange}
                    />

                    <div className='flex gap-4'>
                        <Select
                            isRequired
                            classNames={{ trigger: "bg-white" }}
                            label="Identity Type"
                            labelPlacement='outside'
                            defaultSelectedKeys={formData.identityTypeId}
                            placeholder="Select Identity Type"
                            name="relation1.identityTypeId"
                            onChange={handleChange}
                        >
                            {identity.map((item) => (
                                <SelectItem key={item.id}>{item.name}</SelectItem>
                            ))}
                        </Select>
                        <Input
                            isRequired
                            label="Identity Number"
                            labelPlacement='outside'
                            placeholder='NIC / DL / Passport'
                            type="text"
                            classNames={{
                                inputWrapper: 'bg-white',
                            }}
                            name='relation1.identityNumber'
                            onChange={handleChange}
                        />
                    </div>

                    <Textarea
                        isRequired
                        rows={20}
                        classNames={{ inputWrapper: "bg-white" }}
                        className="col-span-full"
                        label="Residential Address of the Parent/Guardian"
                        labelPlacement='outside'
                        placeholder="Please type your address here..."
                        name='relation1.address'
                        onChange={handleChange}
                    />

                    <Divider className='my-4 col-span-full' />

                    <Select
                        classNames={{ trigger: "bg-white" }}
                        label="Choose Relation"
                        labelPlacement='outside'
                        defaultSelectedKeys={formData.relation}
                        placeholder="Select Relation"
                        name="relation2.relationId"
                        onChange={handleChange}
                    >
                        {relations.map((item) => (
                            <SelectItem key={item.id}>{item.name}</SelectItem>
                        ))}
                    </Select>

                    <Input
                        label="First Name"
                        labelPlacement='outside'
                        placeholder='Rose'
                        type="text"
                        classNames={{
                            inputWrapper: 'bg-white',
                        }}
                        name='relation2.firstName'
                        onChange={handleChange}
                    />

                    <Input
                        label="Last Name"
                        labelPlacement='outside'
                        placeholder='Benet'
                        type="text"
                        classNames={{
                            inputWrapper: 'bg-white',
                        }}
                        name='relation2.lastName'
                        onChange={handleChange}
                    />

                    <Input
                        label="Email Address"
                        labelPlacement='outside'
                        placeholder='example@gmail.com'
                        type="email"
                        classNames={{
                            inputWrapper: 'bg-white',
                        }}
                        name='relation2.email'
                        onChange={handleChange}
                    />

                    <Input
                        label="WhatsApp Number"
                        labelPlacement='outside'
                        placeholder='0761234567'
                        type="text"
                        classNames={{
                            inputWrapper: 'bg-white',
                        }}
                        name='relation2.whatsappNumber'
                        onChange={handleChange}
                    />

                    <div className='flex gap-4'>
                        <Select
                            classNames={{ trigger: "bg-white" }}
                            label="Identity Type"
                            labelPlacement='outside'
                            defaultSelectedKeys={formData.identityTypeId}
                            placeholder="Select Identity Type"
                            name="relation2.identityTypeId"
                            onChange={handleChange}
                        >
                            {identity.map((item) => (
                                <SelectItem key={item.id}>{item.name}</SelectItem>
                            ))}
                        </Select>
                        <Input
                            label="Identity Number"
                            labelPlacement='outside'
                            placeholder='NIC / DL / Passport'
                            type="text"
                            classNames={{
                                inputWrapper: 'bg-white',
                            }}
                            name='relation2.identityNumber'
                            onChange={handleChange}
                        />
                    </div>

                    <Textarea
                        rows={20}
                        classNames={{ inputWrapper: "bg-white" }}
                        className="col-span-full"
                        label="Residential Address of the Parent/Guardian"
                        labelPlacement='outside'
                        placeholder="Please type your address here..."
                        name='relation2.address'
                        onChange={handleChange}
                    />
                </div>

            </div>
            <Button className='mt-5 bg-primary-blue text-white w-fit' radius='sm'
                onPress={handleSubmit}
            >Apply</Button>

            <p className='text-neutral-400'>*By submitting this application, you certify that all information provided is accurate and complete to the best of your knowledge. Any falsification or omission of information may result in the rejection of your application or revocation of admission.</p>
        </div>
    )
}

export default AdmissionForm